/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

const PreformattedText = (props) => (
  <div className={classnames('cmp-preformattedtext', props.className)} style={props.style}>
    <pre>
      {
        props.text ? (
          <div className={props.textClassName}>
            <FormattedMessage
              id={props.text}
              values={props.textValues}
            />
          </div>
        ) : props.children
      }
    </pre>
  </div>
);
PreformattedText.propTypes = {
  children: PropTypes.any,
  text: PropTypes.string,
  textValues: PropTypes.object,
  textClassName: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.any,
};
PreformattedText.defaultProps = {
  textClassName: 'font-footnote',
};

export default PreformattedText;
